import { render, staticRenderFns } from "./default.vue?vue&type=template&id=70d41720&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=70d41720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d41720",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutHeader: require('D:/Project/kpwebsite/PC/components/layout/header.vue').default,LayoutFooters: require('D:/Project/kpwebsite/PC/components/layout/footers.vue').default})
